export const X_DEVICE_FINGERPRINT = 'X-DEVICE-FINGERPRINT';
export const X_SOURCE_VERSION = 'X-SOURCE-VERSION';

export const HTTP_METHODS = {
	GET: 'get',
	POST: 'post',
	PUT: 'put',
	DELETE: 'delete',
	PATCH: 'patch',
};

export const INVALID_CSRF_ERROR_CODE = 'CF004';
export const INVALID_HURDLE_OTP_ERROR_CODE = 'SEN1104';
